import React from "react";
import { IFooter } from "../../cms/interfaces/IFooter";
import CmsGrid from "../../cms/cmp/CmsGrid";
import { Box } from "@mui/material";
import ContentSection from "./ContentSection";


const Footer : React.FC<IFooter> = ({content}) => {
    return <Box sx={{fontSize: '0.85em'}}>
        <ContentSection>
            {content && <CmsGrid {...content} />}
        </ContentSection>
    </Box>
}

export default Footer;